import { render, staticRenderFns } from "./ConsumersView.vue?vue&type=template&id=ce81c2b2&scoped=true"
import script from "./ConsumersView.vue?vue&type=script&lang=js"
export * from "./ConsumersView.vue?vue&type=script&lang=js"
import style0 from "./ConsumersView.vue?vue&type=style&index=0&id=ce81c2b2&prod&scoped=true&lang=css"
import style1 from "./ConsumersView.vue?vue&type=style&index=1&id=ce81c2b2&prod&lang=css"
import style2 from "./ConsumersView.vue?vue&type=style&index=2&id=ce81c2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce81c2b2",
  null
  
)

export default component.exports